
  import React from "react"
  import Component from "/Users/alex/Sites/cv/src/layouts/index.js"
  import data from "/Users/alex/Sites/cv/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js